





















































import { Component, Vue } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
import { ICurrentPage } from '~/store/types';
import TreesPlantedHeader from '~/components/EnvironmentalImpact/TreesPlantedHeader.vue';
import EnvironmentalChangeSteps from '~/components/EnvironmentalImpact/EnvironmentalChangeSteps.vue';
import EnvironmentalCommitment from '~/components/EnvironmentalImpact/EnvironmentalCommitment.vue';

@Component({
  components: {
    TreesPlantedHeader,
    EnvironmentalChangeSteps,
    EnvironmentalCommitment,
  },
})
export default class EnvironmentalImpactPage extends Vue {
  @Mutation updateCurrentPage!: (payload: ICurrentPage) => void;

  async created() {
    this.updateCurrentPage({
      title: 'Impact',
      backIcon: 'arrow_back_ios',
      backRoute: `/`,
    });
  }
}
